<template>
  <div class="flex flex-col justify-between items-center bg-white p-4">
    <div style="padding:56.25% 0 0 0;" class="flex items-center justify-center relative z-10 w-48 lg:w-96"
         v-if="type === 'video'">
      <iframe :src="video"
              style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0"
              allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
    </div>
    <div class="flex flex-1 items-center justify-center relative w-full text-center" v-if="type === 'text'">
      <p class="absolute top-0 left-0 text-medium-blue opacity-25 font-bold -mt-16 lg:-mt-12 -ml-4 lg:ml-0"
         style="font-size: 8rem;">"</p>
      <p class="w-48 lg:w-96">{{ content }}</p>
    </div>
    <h3 class="mt-4">{{ name }}</h3>
  </div>
</template>
<script>
export default {
  name: 'review-card',
  props: {
    name: {},
    type: {},
    video: {},
    content: {}
  }
}
</script>
